import React from 'react';
import '../../styles/components/ui/SectionHeader.css'

const SectionHeader = ({ badge, title, subtitle, icon }) => {
  return (
    <div className="section-header fade-in">
      <div className="section-badge">
        <span className="badge-icon">{icon}</span>
        {badge}
      </div>
      <h2>{title}</h2>
      <div className="accent-line"></div>
      <p>{subtitle}</p>
    </div>
  );
};

export default SectionHeader;